import {InfoContainer, Title, Description} from './styled';

type Props = {
  title: string;
  description: string;
  className?: string;
};

function StepInfoBox({title, description, className}: Props) {
  return (
    <InfoContainer className={className}>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </InfoContainer>
  );
}

export {StepInfoBox};
